import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import { ConsumerConferenceData } from "../../models/api/conference";
import { dateFormatterInYMD, timeFormatterInAMPM } from "../../utils";

export function ModalCalendarUpcomingSchedule(props: {
  scheduleInfo: ConsumerConferenceData;
  show: boolean;
  handleShow: (value: boolean) => void;
}): JSX.Element {
  const rootUrl = process.env.REACT_APP_CLIENT_ROOT || "";

  return (
    <Modal
      show={props.show}
      onHide={() => props.handleShow(false)}
      centered
      className="schedule-modal"
    >
      {/*@ts-ignore */}
      <ModalHeader closeButton>Schedule Detail</ModalHeader>
      <ModalBody>
        <form>
          {props?.scheduleInfo?.assignedUserName && (
            <div className="row">
              <div className="form-group  col-12 col-sm-12 col-md-4">
                <label htmlFor="" className="">
                  User:
                </label>
              </div>
              <div className="form-group col-12 col-sm-12 col-md-8">
                <label htmlFor="" className="text-muted">
                  {props?.scheduleInfo?.assignedUserName}
                </label>
              </div>
            </div>
          )}

          {props?.scheduleInfo?.assignedUserName && (
            <div className="row">
              <div className="form-group  col-12 col-sm-12 col-md-4">
                <label htmlFor="" className="">
                  Company:
                </label>
              </div>
              <div className="form-group col-12 col-sm-12 col-md-8">
                <label htmlFor="" className="text-muted">
                  {props?.scheduleInfo?.assignedUserCompanyName}
                </label>
              </div>
            </div>
          )}

          <div className="row">
            <div className="form-group col-12 col-sm-12 col-md-4">
              <label htmlFor="" className="">
                Time:
              </label>
            </div>
            <div className="form-group col-12 col-sm-12 col-md-8">
              <label htmlFor="" className=" text-muted ">
                {props?.scheduleInfo?.start
                  ? dateFormatterInYMD(props?.scheduleInfo?.start)
                  : ""}
                ,{" "}
                {props?.scheduleInfo?.start
                  ? timeFormatterInAMPM(props?.scheduleInfo?.start)
                  : ""}{" "}
                -{" "}
                {props?.scheduleInfo?.end
                  ? timeFormatterInAMPM(props?.scheduleInfo?.end)
                  : ""}
              </label>
            </div>
          </div>

          <div className="row">
            <div className="form-group col-12 col-sm-12 col-md-4">
              <label htmlFor="" className="">
                Conference Link:
              </label>
            </div>
            <div className="form-group col-12 col-sm-12 col-md-8">
              <a
                className="schedule-link font-sz-12"
                href={
                  props?.scheduleInfo?.roomId
                    ? `${rootUrl}/lobby/${props?.scheduleInfo?.roomId}`
                    : ""
                }
                target="_blank"
                rel="noreferrer"
              >
                {props?.scheduleInfo?.roomId
                  ? `${rootUrl}/lobby/${props?.scheduleInfo?.roomId}`
                  : ""}
              </a>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
